export const PLANNING_TOPICS = Object.freeze({
  CASH_AND_INCOME: {
    topicTitle: 'Cash & Income',
    topicStatement:
      'Knowing your cash flow and net worth provides a snapshot of your current financial position.',
    topicTitleId: '1',
    color: '#06AE93',
    code: 'CASH_AND_INCOME',
  },
  PORTFOLIO_AND_INVESTMENTS: {
    topicTitle: 'Portfolio & Investments',
    topicStatement:
      'Through personalized recommendations, we can support you in aligning your investments with your goals.',
    topicTitleId: '2',
    color: '#3C3E40',
    code: 'PORTFOLIO_AND_INVESTMENTS',
  },
  GOAL_PLANNING: {
    topicTitle: 'Goal Planning',
    topicStatement:
      'Goals are at the foundation of your plan, and we will provide recommendations to help you accomplish what is most important to you.',
    topicTitleId: '3',
    color: '#FED21D',
    code: 'GOAL_PLANNING',
  },
  RISK_AND_PROTECTION: {
    topicTitle: 'Risk & Protection',
    topicStatement:
      'An unexpected event could leave you, or your family, unable to accomplish what matters most to you.',
    topicTitleId: '4',
    color: '#8CBDD9',
    code: 'RISK_AND_PROTECTION',
  },
  ESTATE_AND_WEALTH_TRANSFER: {
    topicTitle: 'Estate & Wealth Transfer',
    topicStatement:
      'A comprehensive estate strategy includes appointing someone to make decisions on your behalf if you are unable to do so.',
    topicTitleId: '5',
    color: '#D2D1D3',
    code: 'ESTATE_AND_WEALTH_TRANSFER',
  },
});

export const planningTopicsMap = new Map([
  [
    PLANNING_TOPICS.CASH_AND_INCOME.topicTitleId,
    PLANNING_TOPICS.CASH_AND_INCOME,
  ],
  [
    PLANNING_TOPICS.PORTFOLIO_AND_INVESTMENTS.topicTitleId,
    PLANNING_TOPICS.PORTFOLIO_AND_INVESTMENTS,
  ],
  [PLANNING_TOPICS.GOAL_PLANNING.topicTitleId, PLANNING_TOPICS.GOAL_PLANNING],
  [
    PLANNING_TOPICS.RISK_AND_PROTECTION.topicTitleId,
    PLANNING_TOPICS.RISK_AND_PROTECTION,
  ],
  [
    PLANNING_TOPICS.ESTATE_AND_WEALTH_TRANSFER.topicTitleId,
    PLANNING_TOPICS.ESTATE_AND_WEALTH_TRANSFER,
  ],
]);
